import { useEffect, useState } from 'react';
import { completeOnboarding, updateProfileBasics } from '../lib/auth';
import Brand from '../components/Brand';

export default function OnboardingPage({ user, profile }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setName(profile?.displayName || user?.displayName || '');
  }, [profile, user]);

  const saveProfile = async (e) => {
    e.preventDefault();
    if (!name.trim()) return setError('Enter your display name.');
    setBusy(true);
    setError('');
    try {
      await updateProfileBasics(user, { displayName: name.trim() });
      await completeOnboarding(user.uid, { displayName: name.trim() });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="onboarding-page">
      <div className="onboarding-card">
        <Brand />
        <p className="eyebrow">WELCOME</p>
        <h1>Finish setting up</h1>
        <p className="auth-sub">Choose how you show up on Sosello.</p>

        <form onSubmit={saveProfile} className="auth-form">
          <label className="field">
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Display name"
              aria-label="Display name"
              required
            />
          </label>
          <p className="hint">We’ll use this on your listings and chats.</p>
          {error && <p className="form-error">{error}</p>}
          <button className="primary-button full" disabled={busy}>
            {busy ? 'Please wait…' : 'Continue to Sosello'}
          </button>
        </form>
      </div>
    </main>
  );
}
